import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQrCode = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 4C2 2.89543 2.89543 2 4 2H10V4H4V10H2V4ZM30 28C30 29.1046 29.1046 30 28 30H22V28H28V22H30V28ZM30 4C30 2.89543 29.1046 2 28 2H22V4L28 4V10H30V4ZM4 30C2.89543 30 2 29.1046 2 28V22H4L4 28L10 28L10 30L4 30ZM15 7H7V15H15V7ZM9 13V9H13V13H9ZM7 17H15V25H7V17ZM9 19V23H13V19H9ZM20 17H17V20H20V22H17V25H20V22H22V25H25V22V20H20V17ZM25 7H17V15H25V7ZM19 13V9H23V13H19Z",
		fill: "inherit"
	})
});
export default SvgQrCode;
